var map = {
	"./1": 242,
	"./1/": 242,
	"./1/index": 242,
	"./1/index.": 242,
	"./1/index.scss": 95641,
	"./1/index.tsx": 242,
	"./2": 59584,
	"./2/": 59584,
	"./2/index": 59584,
	"./2/index.": 59584,
	"./2/index.scss": 55774,
	"./2/index.tsx": 59584,
	"./3": 32592,
	"./3/": 32592,
	"./3/index": 32592,
	"./3/index.": 32592,
	"./3/index.tsx": 32592,
	"./4": 46530,
	"./4/": 46530,
	"./4/index": 46530,
	"./4/index.": 46530,
	"./4/index.scss": 83513,
	"./4/index.tsx": 46530,
	"./5": 13028,
	"./5/": 13028,
	"./5/index": 13028,
	"./5/index.": 13028,
	"./5/index.tsx": 13028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27060;